<template>
<v-layout>
  <v-flex>
  <v-tabs
      v-model="active"
    >
      <v-tab><h6>Organizations</h6></v-tab>
      <v-tab><h6>Infrastructure</h6></v-tab>
      <v-tab><h6>Endpoints</h6></v-tab>
      <v-tab><h6>Users</h6></v-tab>
      <v-tab><h6>Configs</h6></v-tab>
      <v-tab><h6>Worker Sessions</h6></v-tab>
      <v-tab><h6>Audit History</h6></v-tab>
      <v-tab><h6>Integration Tokens</h6></v-tab>
      <v-tab><h6>Org Approvals</h6></v-tab>
      <v-tab><h6>Datafeed</h6></v-tab>
      <v-tab><h6>Type Codes</h6></v-tab>
      <v-tab-item>
        <co-orgs></co-orgs>
      </v-tab-item>
      <v-tab-item>
        <co-systems></co-systems>
      </v-tab-item>
      <v-tab-item>
        <co-endpoints></co-endpoints>
      </v-tab-item>
      <v-tab-item>
        <co-users></co-users>
      </v-tab-item>
      <v-tab-item>
        <co-app-configs></co-app-configs>
      </v-tab-item>
      <v-tab-item>
        <co-worker-sessions></co-worker-sessions>
      </v-tab-item>
      <v-tab-item>
        <audit-history></audit-history>
      </v-tab-item>
      <v-tab-item>
        <integration-tokens></integration-tokens>
      </v-tab-item>
      <v-tab-item>
        <org-approvals></org-approvals>
      </v-tab-item>
      <v-tab-item>
        <datafeed></datafeed>
      </v-tab-item>
      <v-tab-item>
        <type-codes></type-codes>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</v-layout>
</template>

<script>
import AuditHistory from './AuditHistory.vue'
import COAppConfigsList from './COAppConfigsList.vue'
import COEndpointsList from './COEndpointsList.vue'
import COSystemsList from './COSystemsList.vue'
import COUsersList from './COUsersList.vue'
import OrganizationsList from './OrganizationsList.vue'
import COWorkerSessionsList from './COWorkerSessionsList.vue'
import IntegrationTokens from './IntegrationTokens.vue'
import OrgApprovals from './OrgApprovals.vue'
import Datafeed from './Datafeed.vue'
import TypeCodes from './TypeCodes.vue'
import _ from 'lodash'
export default {
  components: {
    // 'log-levels-subpanel': CollectorLogLevelsSubPanel,
    'co-app-configs': COAppConfigsList,
    'co-endpoints': COEndpointsList,
    'co-systems': COSystemsList,
    'co-users': COUsersList,
    'co-orgs': OrganizationsList,
    'co-worker-sessions': COWorkerSessionsList,
    'integration-tokens': IntegrationTokens,
    'org-approvals': OrgApprovals,
    'audit-history': AuditHistory,
    'datafeed': Datafeed,
    'type-codes': TypeCodes
  },
  data() {
    return {
      active: null
    }
  },
  watch: {
    "$route.params.tab"(value) {
      console.log(this.$route.params.tab)
      if (this.$route.params.tab) {
          switch(this.$route.params.tab) {
              case 'infra': this.active = 1; break;
              case 'endpoints': this.active = 2; break;
              case 'users': this.active = 3; break;
              case 'configs': this.active = 4; break;
              case 'sessions': this.active = 5; break;
              case 'auditHistory': this.active = 6; break;
              case 'integrationTokens': this.active = 7; break;
              case 'orgApprovals': this.active = 8; break;
              case 'datafeed': this.active = 9; break;
              case 'typeCodes': this.active = 10; break;
              default: this.active = 0; break;
          }
      }
    }
  },
  created() {
      if (this.$route.params.tab) {
          switch(this.$route.params.tab) {
              case 'infra': this.active = 1; break;
              case 'endpoints': this.active = 2; break;
              case 'users': this.active = 3; break;
              case 'configs': this.active = 4; break;
              case 'sessions': this.active = 5; break;
              case 'auditHistory': this.active = 6; break;
              case 'integrationTokens': this.active = 7; break;
              case 'orgApprovals': this.active = 8; break;
              case 'datafeed': this.active = 9; break;
              case 'typeCodes': this.active = 10; break;
              default: this.active = 0; break;
          }
      }
  }
}
</script>